import TableSettings from "@components/Table/Settings";
import { ColumnLabel } from "@components/Table/Settings/Toolbar";
import { Dialog } from "@rio-cloud/rio-uikit";
import { createCategory, deleteCategory, editCategory, getCategories } from "@services/form";
import { useEffect, useState } from "react";
import { Notification } from "@rio-cloud/rio-uikit";
import DialogCreateCategorySetttings from "@components/Dialog/CreateCategorySettings";

const defaultColumnOrder = ["name", "type", "expenseType"];

const columnLabels: ColumnLabel = {
  id: "1",
  name: "Categoria",
  type: "Tipo da categoria",
  expenseType: "Tipo da despesa",
  date: "",
};

interface IOptionsProps {
  id: number;
  name: string;
  date: string;
}

interface IOptionSelectedProps {
  id: number;
  name: string;
  type?: string;
  expenseType?: string;
}

const CategoriesPage = () => {
  const [createNewModal, setCreateNewModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [options, setOptions] = useState<IOptionsProps[]>([]);
  const [optionSelected, setOptionSelected] = useState<IOptionSelectedProps>();

  const mountOption = (data: any[]) => {
    return data?.map((res: { id: number; name: string; type: string; expenseType: string }) => {
      return {
        id: res.id,
        name: res.name,
        date: "",
        type: res.type,
        expenseType: res.expenseType || "",
      };
    });
  };

  const fetchOptions = async () => {
    try {
      const response = await getCategories();

      setOptions(mountOption(response));
    } catch (error) {
      console.log("error", error);
      setOptions([]);
    }
  };

  useEffect(() => {
    fetchOptions();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSaveNewOption = async (value: string, selectCategory?: string, selectType?: string) => {
    try {
      await createCategory({
        name: value,
        type: selectType as "RECEITA" | "DESPESA",
        expenseType: selectCategory as "DIRETO" | "OPERACIONAL",
      });
      fetchOptions();
      setCreateNewModal(false);
      Notification.success("Categoria criada com sucesso.");
    } catch (error) {
      Notification.error("Não foi possível criar a categoria no momento.");
    }
  };

  const handleEditOption = async (value: string, selectCategory?: string, selectType?: string) => {
    if (!optionSelected?.id) return;

    try {
      await editCategory({
        id: optionSelected?.id,
        name: value,
        type: selectType as "RECEITA" | "DESPESA",
        expenseType: selectCategory as "DIRETO" | "OPERACIONAL",
      });
      fetchOptions();
      setEditModal(false);
      Notification.success("Categoria alterada com sucesso.");
    } catch (error) {
      Notification.error("Não foi possível alterar a categoria no momento.");
    }
  };

  const handleDeleteOption = async (value: string) => {
    if (!optionSelected?.id) return;
    try {
      await deleteCategory(optionSelected?.id);
      fetchOptions();
      setDeleteModal(false);
      Notification.success("Categoria deletada com sucesso.");
    } catch (error) {
      Notification.error("Não foi possível deletar a categoria no momento.");
    }
  };

  return (
    <>
      <TableSettings
        data={options}
        totalData={options.length}
        columnLabels={columnLabels}
        defaultColumnOrder={defaultColumnOrder}
        viewType="TABLE"
        onLoadMore={(res) => console.log(res)}
        handleRefresh={() => {}}
        handleDownload={() => console.log("DOWNLOAD")}
        openModal={() => {
          setCreateNewModal(true);
        }}
        onEdit={(id, name, type, expenseType) => {
          setOptionSelected({ id, name, type, expenseType });
          setEditModal(true);
        }}
        onDelete={(id) => {
          setOptionSelected({ id, name: "" });
          setDeleteModal(true);
        }}
        onDeleteFile={() => {}}
        onGetFile={() => {}}
        onObservation={() => {}}
      />

      <DialogCreateCategorySetttings
        title="Nova categoria"
        show={createNewModal}
        placeholder="Qual o nome da nova categoria?"
        onClose={() => {
          setCreateNewModal(false);
        }}
        onSave={handleSaveNewOption}
      />

      <DialogCreateCategorySetttings
        title="Editar categoria"
        show={editModal}
        placeholder="Qual o novo nome da categoria?"
        onClose={() => {
          setEditModal(false);
        }}
        onSave={(value: string, selectCategory?: string, selectType?: string) =>
          handleEditOption(value, selectCategory, selectType)
        }
        name={optionSelected?.name}
        type={optionSelected?.type}
        expenseType={optionSelected?.expenseType}
      />

      <Dialog
        show={deleteModal}
        title={<span className="text-medium text-size-16">Excluir categoria</span>}
        body={
          <div className="padding-20">
            <p>Tem certeza que deseja excluir esta categoria?</p>
            <p className="text-color-danger">Esta ação não pode ser desfeita.</p>
          </div>
        }
        footer={
          <div className="display-flex gap-10 justify-content-end">
            <button className="btn btn-default" onClick={() => setDeleteModal(false)}>
              Cancelar
            </button>
            <button className="btn btn-danger" onClick={() => handleDeleteOption("")}>
              Excluir
            </button>
          </div>
        }
        onClose={() => setDeleteModal(false)}
        className="exampleDialog"
        showCloseButton
        bsSize="sm"
      />
    </>
  );
};

export default CategoriesPage;
